<template>
  <div class="pay-detail">
    <div class="content-card" >
      <div
        class="tab-inner">
        <div class="tab-item"
             v-for="(item,index) in tabList"
             :key="index"
             :class="{on: item.value == tabName }"
             :style="getActiveStyle(item)"
             @click="tabHandle(item)"
        >
          {{item.label}}
        </div>
      </div>
      <div class="account-list-top-text">{{$t('Transfer_out_account')}}</div>
      <mtaccount-list
        class="mt-list"
        ref="mtlist"
        @send-currentMtInfo="sendCurrentMtInfo"
        @send-accountList="sendAccountList"
      ></mtaccount-list>
      <div class="content">
        <to-self
          :account-list="accountList"
          :current-account="currentMt4"
          v-if="tabName == 'self'"
          @reduce-balance="refreshAccountList"
        ></to-self>
        <to-other
          v-if="tabName == 'other'"
          :account-list="accountList"
          :current-account="currentMt4"
          @reduce-balance="refreshAccountList"
        ></to-other>
      </div>
    </div>
  </div>
</template>

<script>
import mtaccountList from "@/components/public/mtaccountList";
import toOther from "@/components/transfer/toOther";
import toSelf from "@/components/transfer/toSelf";

import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
import { strongPwd } from "@/utils/validate";
export default {
  name: "index",
  components:{
    mtaccountList,
    toSelf,
    toOther,
  },
  data() {
    let _this = this;
    return {
      currentMt4: '',
      accountList: [],
      // 移动端 end
      tabName: 'self',
      tabList:[
        { name:'self',label: _this.$t('Transfer_to_self_held_account')},
        { name:'other',label: _this.$t('Transfer_another_persons_account')},
      ],
      dialogShow: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','withdrawDefaultPageTitle','withdrawDefaultType','themeColor']),
  },
  methods: {
    tabHandle(item){
      this.tabName = item.name;
    },
    getActiveStyle(item){
      if(item.name == this.tabName){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1),
        }
      }
    },
    sendCurrentMtInfo(currentMtInfo){
      this.currentMt4 = currentMtInfo.login;
    },
    sendAccountList(accountList){
      this.accountList = accountList;
    },
    refreshAccountList(){
      this.$refs.mtlist.getCustMtaccount();
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.pay-detail {
  background-color: #ffffff;
  .tips-card,
  .content-card {
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 24px;
    padding: 24px;
    .has-prefix-item {
      /deep/ .el-input__inner {
        padding-left: 60px;
      }
      /deep/ .el-input__prefix {
        left: 16px
      }
    }
  }
  .subtitle {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
    margin-bottom: 20px;
  }
  .tips-card {
    .tips-p {
      color: #5E5873;
    }
  }

  .nav-title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .balance {
    font-size: 16px;
    font-weight: 600;
    color: #D85E5F;
  }
  .mt-list {
    margin-bottom: 20px;
  }
}

</style>
